<template>
  <div id="main-header" class="sticky-navigation">
    <BContainer ref="real_estate_header" class="real_estate_header">
      <div class="d-flex justify-content-center align-items-center">
        <img :src="require('@/assets/img/PP-SecrecyBrokers-Banner-1920-effets.jpg')" width="70%" />
      </div>
      <BRow class="no-gutters justify-content-center">
        <BCol md="8" sm="12">
          <h1 class="app_title text-center">{{ $t("appContent.title") }}</h1>
        </BCol>
      </BRow>
      <BRow class="no-gutters justify-content-center py-3">
        <BCol md="8" sm="12">
          <p class="text-center app_description fs-20px">
            {{ $t("appContent.excerpt") }} <span class="text-red" v-b-modal="`modal_about`" >Read more.</span>
          </p>
        </BCol>
      </BRow>
      <SocialShare :layout="`home`" title="Find out more about the 14 offshore firms at the heart of @ICIJOrg’s #PandoraPapers investigation." share-link="https://www.icij.org/investigations/pandora-papers/secrecy-brokers/"/>
    </BContainer>
  </div>
</template>

<script>
    import SocialShare from '@/components/SocialShare';

export default {
  name: "AppHeader",
  components: {
    SocialShare
  },
  mounted() {},
};
</script>

<style lang="scss">
.sticky-navigation {
  padding: 75px 0 15px 0;
  z-index: 99;
}
.text-red{
  color: var(--app-color-red);
}

</style>
